const MapModal = () => import("@/components/common/mapModal/Index");

export default {
  name: "choose-icon",
  props: {
    state: String,
    id: String,
    close: Function,
  },
  components: {
    MapModal,
  },
  data() {
    return {
      chooseIcon: {
        title: "图标选择",
        id: "chooseIcon",
      },
      modalNode: {
        chooseIcon: {
          show: true,
          loading: false,
          // 样式配置 定位使用
          // style: "margin: 106px 0 0 -706px;",
          offset: {
            // 默认弹出层偏移
            x: 55,
            y: this.$parent.$data.modalNode.plotItem.offset.y - 330,
            // unit: "px", // 默认px
          },
          // width: "450px",
          // auto 自适应
          height: "auto",
          //模态框head配置
          head: {
            //是否能拖动
            canmove: {
              //当前拖动状态
              state: true,
            },
            //折叠配置
            fold: {
              //当前折叠状态
              state: true,
            },
          },
          //模态框中心配置
          // content: {
          //   type: "form",
          //   formData: {
          //     parentId: {
          //       type: "select",
          //       title: "所属目录",
          //       disabled: false,
          //       options: [
          //         {
          //           name: "根目录",
          //           parentId: "-1",
          //           id: "0",
          //           surveilType: "directory",
          //         },
          //       ],
          //     },
          //     name: {
          //       md: 24,
          //       type: "textarea",
          //       title: "目录名称",
          //       rows: 2,
          //       disabled: false,
          //       placeholder: "请填写所属文本",
          //     },
          //     // checkbox: {
          //     //   md: 24,
          //     //   type: "checkbox",
          //     //   title: "复选框",
          //     //   disabled: false,
          //     // },
          //     // parentId1: {
          //     //   md: 24,
          //     //   icon: "$",
          //     //   type: "input",
          //     //   title: "输入框",
          //     //   placeholder: "请输入",
          //     // },
          //     // parentId2: {
          //     //   md: 12,
          //     //   type: "input",
          //     //   title: "所属分类",
          //     // },
          //   },
          //   rules: {
          //     parentId: [
          //       {
          //         required: true,
          //         message: "请选择所属目录",
          //         trigger: "blur",
          //       },
          //     ],
          //     name: [
          //       {
          //         required: true,
          //         message: "请输入目录名称",
          //         trigger: "blur",
          //       },
          //     ],
          //   },
          // },
        },
      },
      form: {
        id: "",
        parentId: "",
        name: "",
      },
      rules: {
        parentId: [
          {
            required: true,
            message: "请选择所属目录",
            trigger: "blur",
          },
        ],
        name: [
          {
            required: true,
            message: "请输入目录名称",
            trigger: "blur",
          },
        ],
      },
      iconsList: [
        "/img/marker/bimPlotIcon/X.png",
        "/img/marker/bimPlotIcon/bulb-front-color.png",
        "/img/marker/bimPlotIcon/calculator-front-color.png",
        "/img/marker/bimPlotIcon/calender-front-color.png",
        "/img/marker/bimPlotIcon/camera-front-color.png",
        "/img/marker/bimPlotIcon/card-front-color.png",
        "/img/marker/bimPlotIcon/chart-front-gradient.png",
        "/img/marker/bimPlotIcon/chat-bubble-front-color.png",
        "/img/marker/bimPlotIcon/clock-front-color.png",
        "/img/marker/bimPlotIcon/colour-palette-front-color.png",
        "/img/marker/bimPlotIcon/copy-front-color.png",
        "/img/marker/bimPlotIcon/explorer-front-color.png",
        "/img/marker/bimPlotIcon/file-text-front-color.png",
        "/img/marker/bimPlotIcon/fire-front-color.png",
        "/img/marker/bimPlotIcon/flag-front-color.png",
        "/img/marker/bimPlotIcon/flash-front-color.png",
        "/img/marker/bimPlotIcon/folder-front-color.png",
        "/img/marker/bimPlotIcon/forward-front-color.png",
        "/img/marker/bimPlotIcon/hash-front-gradient.png",
        "/img/marker/bimPlotIcon/headphone-front-color.png",
        "/img/marker/bimPlotIcon/heart-front-color.png",
        "/img/marker/bimPlotIcon/link-front-color.png",
        "/img/marker/bimPlotIcon/location-front-color.png",
        "/img/marker/bimPlotIcon/lock-front-color.png",
        "/img/marker/bimPlotIcon/mail-front-color.png",
        "/img/marker/bimPlotIcon/map-pin-front-color.png",
        "/img/marker/bimPlotIcon/medal-front-color (1).png",
        "/img/marker/bimPlotIcon/megaphone-front-color.png",
        "/img/marker/bimPlotIcon/mic-front-color.png",
        "/img/marker/bimPlotIcon/moon-front-color.png",
        "/img/marker/bimPlotIcon/music-front-color.png",
        "/img/marker/bimPlotIcon/new-folder-dynamic-color.png",
        "/img/marker/bimPlotIcon/next-front-color.png",
        "/img/marker/bimPlotIcon/notify-heart-front-color.png",
        "/img/marker/bimPlotIcon/paint-kit-front-color.png",
        "/img/marker/bimPlotIcon/pause-front-color.png",
        "/img/marker/bimPlotIcon/pencil-front-color.png",
        "/img/marker/bimPlotIcon/phone-ringing-front-color.png",
        "/img/marker/bimPlotIcon/picture-front-color.png",
        "/img/marker/bimPlotIcon/pin-front-color.png",
        "/img/marker/bimPlotIcon/play-front-color.png",
        "/img/marker/bimPlotIcon/rocket-front-color.png",
        "/img/marker/bimPlotIcon/roll-brush-front-color.png",
        "/img/marker/bimPlotIcon/scissor-front-color.png",
        "/img/marker/bimPlotIcon/setting-front-color.png",
        "/img/marker/bimPlotIcon/sheild-front-gradient.png",
        "/img/marker/bimPlotIcon/sphere-front-color.png",
        "/img/marker/bimPlotIcon/star-front-color.png",
        "/img/marker/bimPlotIcon/sun-front-color.png",
        "/img/marker/bimPlotIcon/target-front-color.png",
        "/img/marker/bimPlotIcon/thumb-up-front-color.png",
        "/img/marker/bimPlotIcon/tick-front-gradient.png",
        "/img/marker/bimPlotIcon/toggle-front-color.png",
        "/img/marker/bimPlotIcon/tool-front-color.png",
        "/img/marker/bimPlotIcon/umbrella-front-color.png",
        "/img/marker/bimPlotIcon/video-camera-front-color.png",
        "/img/marker/bimPlotIcon/wifi-front-color.png",
        "/img/marker/bimPlotIcon/yuan-front-color.png",
        "/img/marker/bimPlotIcon/zoom-front-gradient.png",
        "/img/marker/bimPlotIcon/at-front-01.png",
        "/img/marker/bimPlotIcon/bag-front-color.png",
        "/img/marker/bimPlotIcon/bell-front-color.png",
        "/img/marker/bimPlotIcon/blender-front-color.png",
      ],
    };
  },
  methods: {
    iconInfo(data) {
      this.$emit("getChooseIconInfo", data);
    },
  },
  mounted() {
    console.log(this.$parent.$data.modalNode.plotItem.offset.y);
  },
};
